module.exports = __webpack_public_path__ + "static/media/Slide2.4bb9bbcd.png";